import SettingEdapController from './setting.edap.controller';
import settingEdapHtml from './setting.edap.tpl.html';

export default {
	controller: SettingEdapController,
	template: settingEdapHtml
};
